import { Box } from '@lucidhq/lucidium';
import { Tooltip } from '@lucidhq/lucidium/components/Tooltip';
import { useMemo } from 'react';

const DEFAULT_MAX_TEXT_LENGTH = 8;

export interface EllipsisWithToolTipProps {
  text?: string;
  maxTextLength?: number;
  isTrimmed?: boolean;
}

export const EllipsisWithToolTip = ({
  text,
  maxTextLength = DEFAULT_MAX_TEXT_LENGTH,
  isTrimmed = false,
}: EllipsisWithToolTipProps) => {
  const isTooltipEnabled = useMemo(() => {
    return text !== undefined && text.length > maxTextLength;
  }, [text, maxTextLength]);

  const displayedText =
    isTrimmed && text && text.length > maxTextLength
      ? text.slice(0, maxTextLength) + '...'
      : text;

  return (
    <Tooltip
      title={text}
      placement="top"
      colorScheme="light"
      isDisabled={!isTooltipEnabled}
    >
      <Box
        lss={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {displayedText}
      </Box>
    </Tooltip>
  );
};
